import Axios from "axios";

const ExcelDownloaderPost = (config = { route: "", data: {} }) => {
  Axios({
    method: "post",
    url: config.route,
    data: { ...config.data },
    responseType: "blob",
    headers: { "Content-Type": "application/json" },
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${Date.now()}.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};

export default ExcelDownloaderPost;
